import { _ as __rest } from '../../../tslib.es6-C8rd5pYo.mjs';
import React__default from 'react';
import { TooltipWrapper } from '../TooltipWrapper/TooltipWrapper.es.js';
import { Avatar } from './Avatar.es.js';

const AvatarWithTooltip = (_a) => {
  var { position } = _a, props = __rest(_a, ["position"]);
  return React__default.createElement(TooltipWrapper, { content: props.name, position }, ({ childProps }) => React__default.createElement(Avatar, Object.assign({}, childProps, props, { isBlock: true })));
};

export { AvatarWithTooltip };
//# sourceMappingURL=AvatarWithTooltip.es.js.map
